import generateID from '../../generateID';
import { joinRanges } from './utils/joinRanges';
import { mapRanges } from './utils/mapRanges';
export function addRanges(signals, datum) {
    const ranges = [];
    const { baseFrequency: frequency = 500 } = datum.info;
    for (const signal of signals) {
        const { delta, diaIDs = [], multiplicity = '', integration = 0 } = signal;
        const js = signal.jCoupling || [];
        const fromTo = computeFromTo({ delta, js, frequency });
        if (js && multiplicity) {
            if (js.length === multiplicity.length) {
                js.sort((a, b) => b.coupling - a.coupling);
                for (let i = 0; i < js.length; i++) {
                    js[i].multiplicity = multiplicity[i];
                }
            }
        }
        ranges.push({
            id: generateID(),
            ...fromTo,
            integration,
            signals: [
                {
                    id: generateID(),
                    js,
                    delta,
                    diaIDs,
                    multiplicity,
                },
            ],
        });
    }
    datum.ranges.values = mapRanges(joinRanges(ranges), datum);
}
function computeFromTo(options) {
    const { delta, js: couplings = [], frequency } = options;
    let width = 0.5;
    for (const j of couplings) {
        width += j.coupling;
    }
    width /= frequency;
    return { from: delta - width, to: delta + width };
}
//# sourceMappingURL=addRanges.js.map